export default __webpack_public_path__ + "static/RC_how_we_do_it_icons-03-3d002e1a174aa7140a57d06e32a30c8b.png";